(function () {
  // PC.js
  // 移动端，判空
  if (window.innerWidth < 1024) return;

  console.log("这里是pc 段");


  const productsData = [
    {
      image: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/400_400_1.webp?v=1791363376",
      title: "LuxVision",
      subTitle: "Ultimate Flagship",
      price: "$5,999.00",
      link: "https://awolvision.com/products/luxvision-4k-120hz-ust-projector",
    },
    {
      image:
        "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/max_7b754f8f-66e7-4bc4-97a9-b0805b94306c.webp?v=1787035214",
      title: "Aetherion Max",
      subTitle: "Peak Performance",
      price: "$4,499.00",
      link: "https://awolvision.com/products/4k-3d-triple-laser-projector-ltv-3500-pro",
    },
    {
      image:
        "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/pro_2b9423fa-957b-4578-beac-45adfc8c38a2.webp?v=1787035214",
      title: "Aetherion Pro",
      subTitle: "Pro Essential",
      price: "$3,499.00",
      link: "https://awolvision.com/products/4k-3d-triple-laser-projector-ltv-3000pro",
    },
    {
      image:
        "//awolvision.com/cdn/shop/files/1_ca67cdfe-80a1-4503-a8d6-2bc32181f010_400x.jpg?v=1693912063",
      title: "LTV-3000 Pro",
      subTitle: "Proven Classic",
      price: "$3,999.00",
      link: "https://awolvision.com/products/awol-vision-4k-tri-chroma-laser-projector-ltv-3000pro",
    }
  ];

  const specificationsData = [
    {
      categoryTitle: "Key Features",
      categoryChildren: [
        {
          paramTitle: "Brightness",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_1.svg?v=1726197475",
              text: "6000 ISO Lumens",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_1.svg?v=1726197475",
              text: "3300 ISO Lumens",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_1.svg?v=1726197475",
              text: "2600 ISO Lumens",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_1.svg?v=1726197475",
              text: "2000 ISO Lumens",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Resolution",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_2.svg?v=1726197475",
              text: "4K@120Hz",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_2.svg?v=1726197475",
              text: "4K@60Hz",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_2.svg?v=1726197475",
              text: "4K@60Hz",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_2.svg?v=1726197475",
              text: "4K@60Hz",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Gamut",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_3.svg?v=1726197475",
              text: "110% REC.2020",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_3.svg?v=1726197475",
              text: "110% BT.2020",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_3.svg?v=1726197475",
              text: "110% BT.2020",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_3.svg?v=1726197475",
              text: "107% BT.2020",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Contrast Ratio",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_4.svg?v=1726197475",
              text: "Native Contrast 10000:1 with IRIS;<br> EBL Contrast 100000:1 with IRIS",
              visible: true,
            },
            {
              type: "icon-text",
              text: "Native Contrast 6000:1;<br> EBL Contrast with IRIS 60000:1",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_4.svg?v=1726197475",
              visible: true,
            },
            {
              type: "icon-text",
              text: "Native Contrast 6000:1;<br> EBL Contrast with IRIS 60000:1",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_4.svg?v=1726197475",
              visible: true,
            },
            {
              type: "icon-text",
              text: "Native Contrast 2500:1",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_4.svg?v=1726197475",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Dolby Vision",
          paramChildren: [
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "IMAX Enhanced",
          paramChildren: [
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "No",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Active 3D",
          paramChildren: [
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "ALLM (Auto Low Latency Mode)",
          paramChildren: [
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "No",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "VRR (Variable Refresh Rate)",
          paramChildren: [
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "No",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Input Lag",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_6.svg?v=1726197475",
              text: "1ms",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_6.svg?v=1726197475",
              text: "1ms",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_6.svg?v=1726197475",
              text: "1ms",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_6.svg?v=1726197475",
              text: "15ms",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "HDR",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_7.svg?v=1726197475",
              text: "Dolby Vision, HDR 10+, HDR 10, HLG",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_7.svg?v=1726197475",
              text: "Dolby Vision, HDR 10+, HDR 10, HLG",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_7.svg?v=1726197475",
              text: "Dolby Vision, HDR 10+, HDR 10, HLG",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_7.svg?v=1726197475",
              text: "Dolby Vision, HDR 10+, HDR 10, HLG",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "HDMI",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_8.svg?v=1726197474",
              text: "3xHDMI 2.1+1xDP( DisplayPort via USB-C)",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_8.svg?v=1726197474",
              text: "3xHDMI 2.1+1xDP( DisplayPort via USB-C)",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_8.svg?v=1726197474",
              text: "3xHDMI 2.1+1xDP( DisplayPort via USB-C)",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_8.svg?v=1726197474",
              text: "3*HDMI (eARC on HDMI)",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Audio Performance",
          paramChildren: [
            {
              type: "text",
              text: "Dolby Atmos, DTS:X",
              visible: true,
            },
            {
              type: "text",
              text: "Dolby Atmos, DTS:X",
              visible: true,
            },
            {
              type: "text",
              text: "Dolby Atmos, DTS:X",
              visible: true,
            },
            {
              type: "text",
              text: "Dolby Atmos, DTS Virtual X",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Smart Home Integrated",
          paramChildren: [
            {
              type: "text",
              text: "Google Home, Apple Homekit, Alexa,  and AWOL Vision IP Control",
              visible: true,
            },
            {
              type: "text",
              text: "Google Home, Apple Homekit, Alexa, and AWOL Vision IP Control",
              visible: true,
            },
            {
              type: "text",
              text: "Google Home, Apple Homekit, Alexa, and AWOL Vision IP Control",
              visible: true,
            },
            {
              type: "text",
              text: "PJLink, Control 4, SAVANT and Crestron",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "Projection",
      categoryChildren: [
        {
          paramTitle: "Projection Size",
          paramChildren: [
            {
              type: "text",
              text: "80-200 inches",
              visible: true,
            },
            {
              type: "text",
              text: "80-200 inches",
              visible: true,
            },
            {
              type: "text",
              text: "80-200 inches",
              visible: true,
            },
            {
              type: "text",
              text: "80-150 inches",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "24FPS",
          paramChildren: [
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "ONLY 24FPS",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Throw Ratio",
          paramChildren: [
            {
              type: "text",
              text: "0.18:1",
              visible: true,
            },
            {
              type: "text",
              text: "0.2:1",
              visible: true,
            },
            {
              type: "text",
              text: "0.2:1",
              visible: true,
            },
            {
              type: "text",
              text: "0.25: 1",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Electric Focus",
          paramChildren: [
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Keystone Correction",
          paramChildren: [
            {
              type: "text",
              text: "8 points",
              visible: true,
            },
            {
              type: "text",
              text: "8 points",
              visible: true,
            },
            {
              type: "text",
              text: "8 points",
              visible: true,
            },
            {
              type: "text",
              text: "8 points",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "MEMC",
          paramChildren: [
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "RBE Reduction",
          paramChildren: [
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "No",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "Platform",
      categoryChildren: [
        {
          paramTitle: "Display Technology",
          paramChildren: [
            {
              type: "text",
              text: "TI 0.47 inch DMD with DLPC8555*2",
              visible: true,
            },
            {
              type: "text",
              text: "TI 0.47 inch DMD with DLPC8445",
              visible: true,
            },
            {
              type: "text",
              text: "TI 0.47 inch DMD with DLPC8445",
              visible: true,
            },
            {
              type: "text",
              text: "TI 0.47-inch pico DMD",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "SoC Chipset Platform",
          paramChildren: [
            {
              type: "text",
              text: "AI-SoC MT9655",
              visible: true,
            },
            {
              type: "text",
              text: "Flagship 4K UHD SoC MT9655 with 8GB RAM/128G EMMC memory",
              visible: true,
            },
            {
              type: "text",
              text: "Flagship 4K UHD SoC MT9655 with 8GB RAM/128G EMMC memory",
              visible: true,
            },
            {
              type: "text",
              text: "MT9669",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Light Source",
          paramChildren: [
            {
              type: "text",
              text: "RGB Triple Pure Laser",
              visible: true,
            },
            {
              type: "text",
              text: "RGB Triple Pure Laser",
              visible: true,
            },
            {
              type: "text",
              text: "RGB Triple Pure Laser",
              visible: true,
            },
            {
              type: "text",
              text: "RGB Triple Pure Laser",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Laser Life",
          paramChildren: [
            {
              type: "text",
              text: "25,000+ hours",
              visible: true,
            },
            {
              type: "text",
              text: "25,000+ hours",
              visible: true,
            },
            {
              type: "text",
              text: "25,000+ hours",
              visible: true,
            },
            {
              type: "text",
              text: "25,000+ hours",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Software OS",
          paramChildren: [
            {
              type: "text",
              text: "Google TV OS (Android 14)",
              visible: true,
            },
            {
              type: "text",
              text: "Google TV OS (Android 14)",
              visible: true,
            },
            {
              type: "text",
              text: "Google TV OS (Android 14)",
              visible: true,
            },
            {
              type: "text",
              text: "Android 9.0",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "Audio & Noise",
      categoryChildren: [
        {
          paramTitle: "Noise",
          paramChildren: [
            {
              type: "text",
              text: "-",
              visible: true,
            },
            {
              type: "text",
              text: "28dB",
              visible: true,
            },
            {
              type: "text",
              text: "30dB",
              visible: true,
            },
            {
              type: "text",
              text: "<=27dB",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "Power",
      categoryChildren: [
        {
          paramTitle: "Power Supply",
          paramChildren: [
            {
              type: "text",
              text: "AC 100-240V/50/60Hz",
              visible: true,
            },
            {
              type: "text",
              text: "AC 100-240V@50/60Hz",
              visible: true,
            },
            {
              type: "text",
              text: "AC 100-240V@50/60Hz",
              visible: true,
            },
            {
              type: "text",
              text: "AC 100-240V@50/60Hz",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Standby Mode",
          paramChildren: [
            {
              type: "text",
              text: "0.5 W",
              visible: true,
            },
            {
              type: "text",
              text: "0.5 W",
              visible: true,
            },
            {
              type: "text",
              text: "0.5 W",
              visible: true,
            },
            {
              type: "text",
              text: "0.5 W",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "Connectivity",
      categoryChildren: [
        {
          paramTitle: "USB",
          paramChildren: [
            {
              type: "text",
              text: "1*USB 3.0 and 1 * USB 2.0",
              visible: true,
            },
            {
              type: "text",
              text: "1*USB 3.0 and 1 * USB 2.0",
              visible: true,
            },
            {
              type: "text",
              text: "1*USB 3.0 and 1 * USB 2.0",
              visible: true,
            },
            {
              type: "text",
              text: "2*USB 2.0",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Ethernet Speed",
          paramChildren: [
            {
              type: "text",
              text: "1000Mbps",
              visible: true,
            },
            {
              type: "text",
              text: "1000Mbps",
              visible: true,
            },
            {
              type: "text",
              text: "1000Mbps",
              visible: true,
            },
            {
              type: "text",
              text: "100Mbps",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Digital Audio Output",
          paramChildren: [
            {
              type: "text",
              text: "1*S/PDIF",
              visible: true,
            },
            {
              type: "text",
              text: "1*S/PDIF",
              visible: true,
            },
            {
              type: "text",
              text: "1*S/PDIF",
              visible: true,
            },
            {
              type: "text",
              text: "1*S/PDIF",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Analog Video input",
          paramChildren: [
            {
              type: "text",
              text: "1*AV In",
              visible: true,
            },
            {
              type: "text",
              text: "1*AV In",
              visible: true,
            },
            {
              type: "text",
              text: "1*AV In",
              visible: true,
            },
            {
              type: "text",
              text: "1*AV In",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Wi-Fi",
          paramChildren: [
            {
              type: "text",
              text: "Wi-Fi 7",
              visible: true,
            },
            {
              type: "text",
              text: "Wi-Fi 7",
              visible: true,
            },
            {
              type: "text",
              text: "Wi-Fi 7",
              visible: true,
            },
            {
              type: "text",
              text: "Wi-Fi 5",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Bluetooth",
          paramChildren: [
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Bluetooth 5.4",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Bluetooth 5.4",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Bluetooth 5.4",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Wireless Screen Mirroring",
          paramChildren: [
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Airplay 2, Chromecast, Miracast",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Airplay 2, Chromecast, Miracast",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Airplay 2, Chromecast, Miracast",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "E-share",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "General",
      categoryChildren: [
        {
          paramTitle: "Dimensions",
          paramChildren: [
            {
              type: "text",
              text: "24.25 × 14.06 × 5.83 inches (616*357*148 mm)",
              visible: true,
            },
            {
              type: "text",
              text: "22.1*12.7*5.5 inches / 562*323*139mm",
              visible: true,
            },
            {
              type: "text",
              text: "22.1*12.7*5.5 inches / 562*323*139mm",
              visible: true,
            },
            {
              type: "text",
              text: "23.6*13.9*5.7 inches / 599*353*145 mm",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Weight",
          paramChildren: [
            {
              type: "text",
              text: "15.98 kg / 35.05 lb",
              visible: true,
            },
            {
              type: "text",
              text: "8.35KG/18.4 lb",
              visible: true,
            },
            {
              type: "text",
              text: "8.75KG/19.3 lb",
              visible: true,
            },
            {
              type: "text",
              text: "12 kg /26.5 lb",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Working Temperature",
          paramChildren: [
            {
              type: "text",
              text: "41 - 104 ℉ /5 - 40℃",
              visible: true,
            },
            {
              type: "text",
              text: "41 - 104 ℉ /5 - 40℃",
              visible: true,
            },
            {
              type: "text",
              text: "41 - 104 ℉ /5 - 40℃",
              visible: true,
            },
            {
              type: "text",
              text: "32-104°F / 0-40℃",
              visible: true,
            }
          ],
        },
      ],
    },
  ];

  const diffSpecificationsData = [
    {
      categoryTitle: "Key Features",
      categoryChildren: [
        {
          paramTitle: "Brightness",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_1.svg?v=1726197475",
              text: "6000 ISO Lumens",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_1.svg?v=1726197475",
              text: "3300 ISO Lumens",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_1.svg?v=1726197475",
              text: "2600 ISO Lumens",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_1.svg?v=1726197475",
              text: "2000 ISO Lumens",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Resolution",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_2.svg?v=1726197475",
              text: "4K@120Hz",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_2.svg?v=1726197475",
              text: "4K@60Hz",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_2.svg?v=1726197475",
              text: "4K@60Hz",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_2.svg?v=1726197475",
              text: "4K@60Hz",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Gamut",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_3.svg?v=1726197475",
              text: "110% REC.2020",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_3.svg?v=1726197475",
              text: "110% BT.2020",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_3.svg?v=1726197475",
              text: "110% BT.2020",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_3.svg?v=1726197475",
              text: "107% BT.2020",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Contrast Ratio",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_4.svg?v=1726197475",
              text: "Native Contrast 10000:1 with IRIS;<br> EBL Contrast 100000:1 with IRIS",
              visible: true,
            },
            {
              type: "icon-text",
              text: "Native Contrast 6000:1;<br> EBL Contrast with IRIS 60000:1",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_4.svg?v=1726197475",
              visible: true,
            },
            {
              type: "icon-text",
              text: "Native Contrast 6000:1;<br> EBL Contrast with IRIS 60000:1",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_4.svg?v=1726197475",
              visible: true,
            },
            {
              type: "icon-text",
              text: "Native Contrast 2500:1",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_4.svg?v=1726197475",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "IMAX Enhanced",
          paramChildren: [
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "No",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "ALLM (Auto Low Latency Mode)",
          paramChildren: [
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "No",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "VRR (Variable Refresh Rate)",
          paramChildren: [
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              text: "No",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Input Lag",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_6.svg?v=1726197475",
              text: "1ms",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_6.svg?v=1726197475",
              text: "1ms",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_6.svg?v=1726197475",
              text: "1ms",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_6.svg?v=1726197475",
              text: "15ms",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "HDMI",
          paramChildren: [
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_8.svg?v=1726197474",
              text: "3xHDMI 2.1+1xDP( DisplayPort via USB-C)",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_8.svg?v=1726197474",
              text: "3xHDMI 2.1+1xDP( DisplayPort via USB-C)",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_8.svg?v=1726197474",
              text: "3xHDMI 2.1+1xDP( DisplayPort via USB-C)",
              visible: true,
            },
            {
              type: "icon-text",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_8.svg?v=1726197474",
              text: "3*HDMI (eARC on HDMI)",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Audio Performance",
          paramChildren: [
            {
              type: "text",
              text: "Dolby Atmos, DTS:X",
              visible: true,
            },
            {
              type: "text",
              text: "Dolby Atmos, DTS:X",
              visible: true,
            },
            {
              type: "text",
              text: "Dolby Atmos, DTS:X",
              visible: true,
            },
            {
              type: "text",
              text: "Dolby Atmos, DTS Virtual X",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Smart Home Integrated",
          paramChildren: [
            {
              type: "text",
              text: "Google Home, Apple Homekit, Alexa,  and AWOL Vision IP Control",
              visible: true,
            },
            {
              type: "text",
              text: "Google Home, Apple Homekit, Alexa, and AWOL Vision IP Control",
              visible: true,
            },
            {
              type: "text",
              text: "Google Home, Apple Homekit, Alexa, and AWOL Vision IP Control",
              visible: true,
            },
            {
              type: "text",
              text: "PJLink, Control 4, SAVANT and Crestron",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "Projection",
      categoryChildren: [
        {
          paramTitle: "Projection Size",
          paramChildren: [
            {
              type: "text",
              text: "80-200 inches",
              visible: true,
            },
            {
              type: "text",
              text: "80-200 inches",
              visible: true,
            },
            {
              type: "text",
              text: "80-200 inches",
              visible: true,
            },
            {
              type: "text",
              text: "80-150 inches",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "24FPS",
          paramChildren: [
            {
              type: "text",
              text: "-",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "ONLY 24FPS",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Throw Ratio",
          paramChildren: [
            {
              type: "text",
              text: "0.18:1",
              visible: true,
            },
            {
              type: "text",
              text: "0.2:1",
              visible: true,
            },
            {
              type: "text",
              text: "0.2:1",
              visible: true,
            },
            {
              type: "text",
              text: "0.25: 1",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "RBE Reduction",
          paramChildren: [
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "No",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "Platform",
      categoryChildren: [
        {
          paramTitle: "Display Technology",
          paramChildren: [
            {
              type: "text",
              text: "TI 0.47 inch DMD with 2x/4x/8x pixel shift",
              visible: true,
            },
            {
              type: "text",
              text: "TI 0.47 inch DMD with DLPC8445",
              visible: true,
            },
            {
              type: "text",
              text: "TI 0.47 inch DMD with DLPC8445",
              visible: true,
            },
            {
              type: "text",
              text: "TI 0.47-inch pico DMD",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "SoC Chipset Platform",
          paramChildren: [
            {
              type: "text",
              text: "MT9667",
              visible: true,
            },
            {
              type: "text",
              text: "Flagship 4K UHD SoC MT9655 with 8GB RAM/128G EMMC memory",
              visible: true,
            },
            {
              type: "text",
              text: "Flagship 4K UHD SoC MT9655 with 8GB RAM/128G EMMC memory",
              visible: true,
            },
            {
              type: "text",
              text: "MT9669",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Light Source",
          paramChildren: [
            {
              type: "text",
              text: "RGB Triple Pure Laser",
              visible: true,
            },
            {
              type: "text",
              text: "RGB Triple Pure Laser",
              visible: true,
            },
            {
              type: "text",
              text: "RGB Triple Pure Laser",
              visible: true,
            },
            {
              type: "text",
              text: "RGB Triple Pure Laser",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Software OS",
          paramChildren: [
            {
              type: "text",
              text: "Google TV OS (Android 14)",
              visible: true,
            },
            {
              type: "text",
              text: "Google TV OS (Android 14)",
              visible: true,
            },
            {
              type: "text",
              text: "Google TV OS (Android 14)",
              visible: true,
            },
            {
              type: "text",
              text: "Android 9.0",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "Audio & Noise",
      categoryChildren: [
        {
          paramTitle: "Noise",
          paramChildren: [
            {
              type: "text",
              text: "-",
              visible: true,
            },
            {
              type: "text",
              text: "28dB",
              visible: true,
            },
            {
              type: "text",
              text: "30dB",
              visible: true,
            },
            {
              type: "text",
              text: "<=27dB",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "Power",
      categoryChildren: [
        {
          paramTitle: "Power Supply",
          paramChildren: [
            {
              type: "text",
              text: "AC 100-240V/50/60Hz",
              visible: true,
            },
            {
              type: "text",
              text: "AC 100-240V@50/60Hz",
              visible: true,
            },
            {
              type: "text",
              text: "AC 100-240V@50/60Hz",
              visible: true,
            },
            {
              type: "text",
              text: "AC 100-240V@50/60Hz",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "Connectivity",
      categoryChildren: [
        {
          paramTitle: "USB",
          paramChildren: [
            {
              type: "text",
              text: "1*USB 3.0 and 1 * USB 2.0",
              visible: true,
            },
            {
              type: "text",
              text: "1*USB 3.0 and 1 * USB 2.0",
              visible: true,
            },
            {
              type: "text",
              text: "1*USB 3.0 and 1 * USB 2.0",
              visible: true,
            },
            {
              type: "text",
              text: "2*USB 2.0",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Ethernet Speed",
          paramChildren: [
            {
              type: "text",
              text: "1000Mbps",
              visible: true,
            },
            {
              type: "text",
              text: "1000Mbps",
              visible: true,
            },
            {
              type: "text",
              text: "1000Mbps",
              visible: true,
            },
            {
              type: "text",
              text: "100Mbps",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Wi-Fi",
          paramChildren: [
            {
              type: "text",
              text: "Wi-Fi 7",
              visible: true,
            },
            {
              type: "text",
              text: "Wi-Fi 7",
              visible: true,
            },
            {
              type: "text",
              text: "Wi-Fi 7",
              visible: true,
            },
            {
              type: "text",
              text: "Wi-Fi 5",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Bluetooth",
          paramChildren: [
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Bluetooth 5.4",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Bluetooth 5.4",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Bluetooth 5.4",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Yes",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Wireless Screen Mirroring",
          paramChildren: [
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Airplay 2, Chromecast, Miracast",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Airplay 2, Chromecast, Miracast",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "Airplay 2, Chromecast, Miracast",
              visible: true,
            },
            {
              type: "icon",
              icon: "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_11.svg?v=1726197475",
              text: "E-share",
              visible: true,
            }
          ],
        },
      ],
    },
    {
      categoryTitle: "General",
      categoryChildren: [
        {
          paramTitle: "Dimensions",
          paramChildren: [
            {
              type: "text",
              text: "24.25 × 14.06 × 5.83 inches (616*357*148 mm)",
              visible: true,
            },
            {
              type: "text",
              text: "22.1*12.7*5.5 inches / 562*323*139mm",
              visible: true,
            },
            {
              type: "text",
              text: "22.1*12.7*5.5 inches / 562*323*139mm",
              visible: true,
            },
            {
              type: "text",
              text: "23.6*13.9*5.7 inches / 599*353*145 mm",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Weight",
          paramChildren: [
            {
              type: "text",
              text: "15.98 kg / 35.05 lb",
              visible: true,
            },
            {
              type: "text",
              text: "8.35KG/18.4 lb",
              visible: true,
            },
            {
              type: "text",
              text: "8.75KG/19.3 lb",
              visible: true,
            },
            {
              type: "text",
              text: "12 kg /26.5 lb",
              visible: true,
            }
          ],
        },
        {
          paramTitle: "Working Temperature",
          paramChildren: [
            {
              type: "text",
              text: "41 - 104 ℉ /5 - 40℃",
              visible: true,
            },
            {
              type: "text",
              text: "41 - 104 ℉ /5 - 40℃",
              visible: true,
            },
            {
              type: "text",
              text: "41 - 104 ℉ /5 - 40℃",
              visible: true,
            },
            {
              type: "text",
              text: "32-104°F / 0-40℃",
              visible: true,
            }
          ],
        },
      ],
    },
  ];

  const createShowDiffWrapEle = () => {
    const wrap = document.createElement("div");

    wrap.className = "show-diff-wrap";

    wrap.innerHTML = `
    <span class="diff-check-btn">
      <img src="https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_14.svg?v=1726312631" alt="Show difference">
    </span>
    <span class="diff-text">Only show difference</span>`;

    return wrap;
  };

  const createProductEles = () => {
    return productsData.map((pcProduct) => {
      const productWrap = document.createElement("div");

      productWrap.className = "product-wrap";

      productWrap.innerHTML = `
        <img src="${pcProduct.image}" alt="" class="image">
        <span class="title">${pcProduct.title}</span>
        <span class="sub-title">${pcProduct.subTitle}</span>
        <span class="price">${pcProduct.price}</span>
        <a class="shop-now" href="${pcProduct.link}">SHOP NOW</a>
      `;

      return productWrap;
    });
  };

  const renderProducts = () => {
    // 获取容器元素
    const container = document.querySelector(".product-introduction-wrap");

    container.appendChild(createShowDiffWrapEle());

    createProductEles().forEach((productEle) =>
      container.appendChild(productEle)
    );
  };

  const renderSpecificationsList = (data, rootEle) => {
    rootEle.innerHTML = "";

    const renderParamsChildren = (children) => {
      let template = "";

      children.forEach((item) => {
        if (!item.visible) {
          return (template += `
            <div class="param-item-2"><span>-</span></div>
          `);
        }

        if (item.type === "icon-text") {
          return (template += `
          <div class="param-item-1"><img src="${item.icon}" /><span>${item.text}</span></div>
        `);
        }

        if (item.type === "icon") {
          if (item.text) {
            const iconHtml = item.icon ? `<img src="${item.icon}" />` : "";

            return (template += `
          <div class="param-item-1">${iconHtml}<span>${item.text}</span></div>
        `);
          }

          if (!item.icon) {
            return (template += `
          <div class="param-item-2"></div>
        `);
          }

          return (template += `
          <div class="param-item-2"><img src="${item.icon}" /></div>
        `);
        }

        if (item.type === "text") {
          return (template += `
          <div class="param-item-2">${item.text || ""}</div>
        `);
        }
      });

      return template;
    };

    const renderCategoryChildren = (children) => {
      let template = "";

      children.forEach((item) => {
        const itemStr = `
        <div class="param-items-wrap">
          <span class="param-title">${item.paramTitle}</span>
          ${renderParamsChildren(item.paramChildren)}
        </div>
        `;

        template += itemStr;
      });

      return template;
    };

    data.forEach((category) => {
      if (category.categoryTitle === "Audio & Noise") return;

      const categoryWrap = document.createElement("div");

      categoryWrap.className = "product-category-wrap";

      categoryWrap.innerHTML = `
          <div class="category-title-wrap">
            <span class="category-title">${category.categoryTitle}</span>
            <img  class="category-expand-btn" src="https://cdn.shopify.com/s/files/1/0554/7445/4576/files/projectors_comparison_icon_13.svg?v=1726296238" />
          </div>
          <div class="params-list-wrap">
          ${renderCategoryChildren(category.categoryChildren)}

          </div>
      `;

      rootEle.appendChild(categoryWrap);
    });
  };

  const isPanelOpen = (panel) => {
    if (panel.classList.contains("is-expanded")) return true;
    if (panel.dataset.animId) return true;

    return !["", "0", "0px"].includes(panel.style.maxHeight);
  };

  const watchPanelHeight = (panel) => {
    if (panel.dataset.heightWatch === "1") return;

    panel.dataset.heightWatch = "1";

    const sync = () => {
      if (panel.classList.contains("is-expanded")) return;
      if (["", "0", "0px"].includes(panel.style.maxHeight)) return;

      panel.style.maxHeight = `${panel.scrollHeight}px`;
    };

    panel.querySelectorAll("img").forEach((img) => {
      if (!img.complete) img.addEventListener("load", sync);
    });

    if (document.fonts?.ready) {
      document.fonts.ready.then(sync);
    }
  };

  const whenPanelReady = (panel) => {
    const imageTasks = [...panel.querySelectorAll("img")]
      .filter((img) => !img.complete)
      .map(
        (img) =>
          new Promise((resolve) => {
            img.addEventListener("load", resolve, { once: true });
            img.addEventListener("error", resolve, { once: true });
          })
      );

    return Promise.all([
      document.fonts?.ready || Promise.resolve(),
      ...imageTasks,
    ]);
  };

  const openPanel = (panel) => {
    const animId = `${Date.now()}-${Math.random()}`;

    panel.dataset.animId = animId;
    panel.classList.remove("is-expanded");
    panel.style.overflow = "hidden";

    whenPanelReady(panel).then(() => {
      if (panel.dataset.animId !== animId) return;

      panel.style.maxHeight = `${panel.scrollHeight}px`;
      watchPanelHeight(panel);

      const finish = () => {
        if (panel.dataset.animId !== animId) return;
        if (panel.style.maxHeight === "0px") return;

        panel.dataset.animId = "";
        panel.classList.add("is-expanded");
        panel.style.maxHeight = "";
        panel.style.overflow = "";
      };

      panel.addEventListener("transitionend", function onEnd(event) {
        if (event.target !== panel || event.propertyName !== "max-height") return;

        panel.removeEventListener("transitionend", onEnd);
        finish();
      });

      window.setTimeout(finish, 700);
    });
  };

  const closePanel = (panel) => {
    const waiting =
      !panel.classList.contains("is-expanded") &&
      ["", "0", "0px"].includes(panel.style.maxHeight);

    panel.dataset.animId = "";
    panel.style.overflow = "hidden";

    if (waiting) {
      panel.style.maxHeight = "0px";
      return;
    }

    const height = panel.scrollHeight;

    panel.style.maxHeight = `${height}px`;
    panel.classList.remove("is-expanded");
    panel.offsetHeight;
    panel.style.maxHeight = "0px";
  };

  const togglePanel = (panel) => {
    if (isPanelOpen(panel)) {
      closePanel(panel);
      return;
    }

    openPanel(panel);
  };

  const productCategoryApi = {
    getAll() {
      return document.querySelectorAll(
        ".product-specifications-list-container .product-category-wrap"
      );
    },

    expandAll() {
      const productCategoryWrapEles = this.getAll();

      productCategoryWrapEles.forEach((ele) => this.expandTargetEle(ele));
    },
    expandTargetEle(targetEle) {
      const paramsListWrap = targetEle.querySelector(".params-list-wrap");

      targetEle
        .querySelector(".category-title-wrap .category-expand-btn")
        .classList.toggle("flip-over");

      togglePanel(paramsListWrap);
    },

    expand(num = 1) {
      if (!num) return;

      const productCategoryWrapEles = this.getAll();

      const targetEle = productCategoryWrapEles[num - 1];

      this.expandTargetEle(targetEle);
    },

    hideBtn(num) {
      if (!num) return;

      const categoryTitleWrapEle = document.querySelectorAll(
        ".product-specifications-list-container .product-category-wrap .category-title-wrap"
      )[num - 1];

      categoryTitleWrapEle.onclick = null;

      const btnEle = categoryTitleWrapEle.querySelector(".category-expand-btn");

      btnEle.style.display = "none";
    },

    flipAllBtn() {
      // 找到 .product-category-wrap 和它的子集 .params-list-wrap
      const eles = document.querySelectorAll(
        ".product-category-wrap .category-expand-btn"
      );
      // 切换'flip-over'类来触发 箭头翻转 动画
      eles.forEach((ele) => ele.classList.toggle("flip-over"));
    },
  };

  const scrollApi = {
    scrollToShowDiffBtn() {
      document.documentElement.scrollTo(0, 500);
    },
  };

  /**
   * 监听展示差异按钮
   */
  const listenShowDiffBtn = () => {
    const showDiffBtnWrapEle = document.querySelector(".show-diff-wrap");

    const diffBtnWrap = showDiffBtnWrapEle.querySelector(".diff-check-btn");

    const hookIconEle = showDiffBtnWrapEle.querySelector("img");

    let showDiff = false;
    let isAnimating = false; // 防止在动画期间触发多次点击

    showDiffBtnWrapEle.addEventListener("click", function () {
      // 获取容器元素
      const container = document.querySelector(
        ".product-specifications-list-container"
      );

      // 如果正在动画，忽略点击
      if (isAnimating) return;
      isAnimating = true;

      // 开始隐藏现有内容，淡出
      container.style.opacity = "0";

      // 等待淡出动画完成
      setTimeout(() => {
        // 是否展示差异 or 全部内容
        if (showDiff) {
          diffBtnWrap.style.backgroundColor = "#EAEAEA";

          hookIconEle.style.opacity = 1;

          renderSpecificationsList(diffSpecificationsData, container);

          productCategoryApi.expandAll();
        } else {
          hookIconEle.style.opacity = 0;

          diffBtnWrap.style.backgroundColor = "#fff";

          renderSpecificationsList(specificationsData, container);

          productCategoryApi.expand(1);
        }

        productCategoryApi.hideBtn(1);

        // 切换内容后淡入
        container.style.display = "block";

        container.style.opacity = "1";

        scrollApi.scrollToShowDiffBtn();

        listenCategoryExpandBtn();

        // 标记动画结束
        setTimeout(() => {
          isAnimating = false;
        }, 600); // 与 transition 动画时长一致
      }, 700); // 等待 1 秒，让淡出动画完成

      showDiff = !showDiff;
    });
  };

  /**
   * 监听展开收起按钮
   */
  const listenCategoryExpandBtn = () => {
    const handleClick = (targetEle) => {
      productCategoryApi.expandTargetEle(
        targetEle.closest(".product-category-wrap")
      );
    };

    const handleSingle = (targetEle) => {
      // 绑定点击事件
      targetEle.addEventListener("click", () => handleClick(targetEle));
    };

    // 找到所有 .category-expand-btn 元素
    const categoryTitleWraps = document.querySelectorAll(
      ".category-title-wrap"
    );

    categoryTitleWraps.forEach((categoryTitleWrap, index) => {
      // 第一个过滤不监听
      if (index === 0) return;

      handleSingle(categoryTitleWrap);
    });
  };

  /**
   * 监听窗口滚动
   */
  const listenWindowScroll = () => {
    window.addEventListener("scroll", function () {
      // 获取元素
      const productContainer = document.querySelector(
        ".product-introduction-container"
      );

      const productContainerFillHeight = document.querySelector(
        ".product-introduction-container-fill-height"
      );

      // 获取当前滚动条距离视窗顶部的距离
      const scrollPosition = window.scrollY;

      // 当滚动条距离顶部 638px 时，添加类 "ceiling"
      if (scrollPosition >= 638) {
        productContainerFillHeight.style.height = 553 + "px";

        productContainer.classList.add("ceiling");
      } else {
        productContainer.classList.remove("ceiling");

        productContainerFillHeight.style.height = "0px";
      }
    });
  };

  const init = () => {
    renderProducts();

    // 获取容器 元素
    const SpecificationsListcontainerEle = document.querySelector(
      ".product-specifications-list-container"
    );

    renderSpecificationsList(
      specificationsData,
      SpecificationsListcontainerEle
    );

    SpecificationsListcontainerEle.style.opacity = "1";

    productCategoryApi.expand(1);

    productCategoryApi.hideBtn(1);

    listenCategoryExpandBtn();

    listenShowDiffBtn();

    listenWindowScroll();
  };

  init();
})();
